import styled from 'styled-components'

export default styled.div`
  width: 50px;
  font-weight: bold;
`
